module.exports = __webpack_public_path__ + "img/custom_boston_02.6c1d13e0.png";